export default "__VITE_ASSET__BSj7Bjg2__"